import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { ProgressBar } from './components/ProgressBar';
import { CheckCard } from './components/CheckCard';
import { Completion } from './components/Completion';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { checks } from './data/checks';
export function App() {
  const [doneIds, setDoneIds] = useState<string[]>([]);
  const toggleStep = (id: string) => {
    setDoneIds(current => current.includes(id) ? current.filter(item => item !== id) : [...current, id]);
  };
  const allDone = doneIds.length === checks.length;
  return <div className="min-h-full w-full bg-paper font-sans text-ink" data-id="element-0" data-mp="31ctefp14jw7l">
      <Hero data-id="element-1" data-mp="2wj8cxn0bok3n" />
      <ProgressBar completed={doneIds.length} total={checks.length} data-id="element-2" data-mp="2wifgpfyzpczr" />

      <main className="mx-auto w-full max-w-readable px-6 py-12 sm:py-16" data-id="element-3" data-mp="28tmej1rry8wp">
        <h2 className="sr-only" data-id="element-4" data-mp="23vkv2fqfs7kp">Las 5 verificaciones del Protocolo CNS</h2>
        <div className="space-y-5" data-id="element-5" data-mp="23ti8y6semyl9">
          {checks.map(step => <CheckCard key={step.id} step={step} done={doneIds.includes(step.id)} onToggle={toggleStep} data-id="element-6" data-mp="3ijfv1zlojwem" />)}
        </div>

        <div className="mt-8" data-id="element-7" data-mp="3rcswjpxt86cb">
          <Completion allDone={allDone} data-id="element-8" data-mp="3relwynhtxubv" />
        </div>
      </main>

      <Offer data-id="element-9" data-mp="5ggxfcks0yi" />
      <Footer data-id="element-10" data-mp="82kl3wchwbg" />
    </div>;
}